export const createAdminLeagueRes = (state) => state.createAdminLeague;
export const leagues = (state) => state.leagues.data;
export const leaguesLoading = (state) => state.leagues.loading;
export const moreLeaguesLoading = (state) => state.moreLeaguesLoading;
export const pendingProfileInvitationsRes = (state) =>
  state.pendingProfileInvitations;
export const answerLeagueInvitationRes = (state) =>
  state.answerLeagueInvitation;
export const league = (state) => state.league;
export const leagueRules = (state) => state.leagueRules;
export const myLeaguePortfolios = (state) => state.myLeaguePortfolios;
export const leaguePortfolios = (state) => state.leaguePortfolios;
export const submitLeaguePassword = (state) => state.submitLeaguePassword;
export const leagueFeed = (state) => state.league.feed.data;
export const leagueFeedLoading = (state) => state.league.feed.loading;
export const leagueFeedLeagueId = (state) => state.league.feed.leagueId;
export const loadingNextLeaguePosts = (state) =>
  state.league.feed.loadingNextPosts;
